import React from 'react';
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import {makeStyles, ThemeOptions} from "@material-ui/core/styles";

function SlideTransition(props: any) {
	return <Slide {...props} direction="right" />;
}

export enum SEVERITY {
	ERROR = 'error',
	SUCCESS = 'success',
	WARNING = 'warning',
	INFO = 'info'
}

const useStyles = makeStyles((theme: ThemeOptions) => ({
	container: (props: any) => ({
		backgroundColor: props.severity === SEVERITY.ERROR ? '#F44336' : props.severity === SEVERITY.WARNING ? '#FF9800' : props.severity === SEVERITY.SUCCESS ? '#4CAF50' : '#2196F3',
		color: 'white',
		padding: '12px'
	}),
	icon: {
		display: "flex",
		alignItems: "center",
		marginRight: '8px'
	},
	text: {
		display: "flex",
		alignItems: "center",
		marginRight: '8px'
	},
	action: {
		display: "flex",
		alignItems: "center",
		marginRight: '-8px',
		marginLeft: '-8px'
	}
}));

interface Props {
	showSnackBar: boolean;
	onClose: () => void;
	message: string;
	severity: SEVERITY.ERROR | SEVERITY.WARNING | SEVERITY.SUCCESS | SEVERITY.INFO
}

const GenericSnackbar = (props: Props) => {
	const { showSnackBar, onClose, message, severity } = props;
	const classes = useStyles(props);
	return (
		<Snackbar
			anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			autoHideDuration={3000}
			open={showSnackBar}
			onClose={onClose}
			TransitionComponent={SlideTransition}
			key={SlideTransition.name}
		>
			<Grid container className={classes.container}>
				<div className={classes.icon}>
					{
						severity === SEVERITY.ERROR
							? <ErrorOutlineIcon fontSize={"small"} />
							: severity === SEVERITY.WARNING
							? <WarningIcon fontSize={"small"} />
							: severity === SEVERITY.SUCCESS
								? <CheckCircleIcon fontSize={"small"} />
								: <InfoIcon fontSize={"small"} />
					}
				</div>
				<div className={classes.text}>
					<Typography variant={"subtitle2"}>{message}</Typography>
				</div>
				<div className={classes.action}>
					<IconButton size={"small"} onClick={onClose}>
						<CloseIcon fontSize={"small"}/>
					</IconButton>
				</div>
			</Grid>
		</Snackbar>
	);
};

export default GenericSnackbar;